import { downloadFile } from '@acme/foundation';
import { useUnit } from 'effector-react';
import { useCallback } from 'react';
import { Message } from '../../model';
import { useChatWindowModel } from '../../lib/chatwindowcontext';
import { MessageBubble } from './bubble';
import { MessageHeader } from './header';

export interface MessageItemProps {
  message: Message;
  variant?: 'default' | 'ticket';
}

export const MessageItem = (props: MessageItemProps) => {
  const model = useChatWindowModel();
  const { companionLabelText, getAttachmentReq } = useUnit({
    companionLabelText: model.$companionLabelText,
    getAttachmentReq: model.$getAttachmentReq,
  });

  const isUser = !props.message.isAnswer;
  const senderName = isUser ? 'Вы' : companionLabelText;
  const variant: 'default' | 'ticket' = props.variant ?? 'default';

  const handleDownload = useCallback(
    async (id: string, fileName: string) => {
      if (!getAttachmentReq) return;
      try {
        const response = await getAttachmentReq({ id });
        downloadFile({ data: response, fileName });
      } catch (error) {
        console.error('Download failed:', error);
      }
    },
    [getAttachmentReq]
  );

  return (
    <div
      className={`flex ${!isUser || variant === 'ticket' ? 'justify-start' : 'justify-end'}`}
    >
      <div className={`flex flex-col max-w-[85%] gap-1`}>
        <MessageHeader
          variant={variant}
          senderName={senderName}
          sentAt={props.message.sentAt as string}
          isUser={isUser}
        />

        <MessageBubble
          variant={variant}
          isUser={isUser}
          text={props.message.text}
          attachments={props.message.attachments}
          onDownload={(id, fileName) => handleDownload(id, fileName)}
        />
      </div>
    </div>
  );
};
